import React, { useEffect, useState, useRef } from 'react';
import { Avatar, Button, Card, IconBell } from "@veneer/core";
import { Form } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import './header.scss';
import { useTranslation } from 'react-i18next';
import { toggleBanner, openBanner } from '@store/reducers/bannerSlice';
import { useAppDispatch } from '@store/hooks';
import './header.scss';


const divStyle = {
  zIndex: '99',
};

const styles: { [key: string]: React.CSSProperties } = {
	avatarPadding: {
		paddingRight: '24px',
	},
  wrapper: {
    position: 'relative',
    display: 'inline-block',
  },
  
  container: {
    minWidth: '255px',
    position: 'absolute',
    top: 'calc(100% + 7px)',
    right: '4px',
    padding: '16px',
    border: '1px solid #ccc',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    backgroundColor: '#fff',
    zIndex: 1000,
  },
  detailsContainer: {
    display:"flex",
    flexDirection:'column',
    alignItems:'center'
  },
  name: {
    fontSize: '16px',
    fontWeight: 'bold',
    marginBottom: '4px',
    color: '#333',
  },
  email: {
    fontSize: '14px',
    color: '#666',
    marginBottom: '12px',
  },
  signOutButton: {
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    padding: '8px 16px',
    cursor: 'pointer',
  },
};

const handleSignout = () => {
  localStorage.clear();
    //Bug 531056: Portal redirect Url is broken
  //const signoutUrl = `https://directory.stg.cd.id.hp.com/directory/v1/oauth/logout?post_logout_redirect_uri=${(window as any).location.origin}/Account/Login/LogOff/`;
  const signoutUrl = (window as any).logouturl
  window.location.href = signoutUrl;
};

const firstname: string = (window as any).username ? (window as any).username : "Firstname";
const lastname: string = (window as any).lastname ? (window as any).lastname : "Lastname";
const email: string = (window as any).email ? (window as any).email : "welcome@hp.com";

const Header: React.FC = () => {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const popupRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const {t} = useTranslation();

  const dispatch = useAppDispatch();
  const shouldRenderSideNav = !window.location.pathname.includes("signup");

  const toggleVisibility = (): void => {
    setIsVisible(!isVisible);
  };

  const navigateToProfile =()=>{
    navigate(`/profile`);
  }

  const handleClickOutside = (event: MouseEvent): void => {
    if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
      setIsVisible(false);
    }
  };

  const [isHeaderLoaded, setIsHeaderLoaded] = useState(false);

  const pathNameArray: string[] = (window as any).location.pathname.split('/');
  const pathSeparator: string[] = pathNameArray[1].split('-');
  const countryLang: string = pathSeparator[0].toLowerCase();
  const countryID: string = pathSeparator[1].toLowerCase();

  useEffect(() => {
    const scriptId = 'header-script';
    if (!document.getElementById(scriptId)) {
		const HeaderURL = `https://ssl.www8.hp.com/caas/header-footer/${countryID}/${countryLang}/default/latest.r?contentType=js;hide_search=true;show_shopping_cart=false;search_section_order=support-shop-explore;hide_country_selector=true&amp;show_sign_in=false`;
		const headerscript = document.createElement('script');
		headerscript.setAttribute('type', 'text/javascript');
		headerscript.setAttribute('src', HeaderURL);
		headerscript.setAttribute('id', scriptId);
		headerscript.async = true;
		headerscript.defer = true;
		document.head.appendChild(headerscript);
		headerscript.onload = () => {
		  const hideLogoAndCart = () => {
			if (!window.location.href.includes('signup')) {
			  const hplogo = document.querySelectorAll<HTMLElement>('.wpr-main-logo-svg');
			  if (hplogo.length > 0) {
				hplogo.forEach((logo) => {
				  logo.style.display = 'none';
				  // console.log('HP logo hidden');
				});
			  } else {
				console.log('Retrying to hide HP logo');
				setTimeout(hideLogoAndCart, 10); // Retry after 100ms
			  }
			}else{
        const header = document.getElementById('customHeader');
        if (header) {
          header.style.position = "relative";
        }
      }
			const cart = document.querySelectorAll<HTMLElement>('.wpr-hpcart');
			// if (cart.length > 0) {
			//   cart.forEach((cartItem) => {
			// 	cartItem.style.display = 'none';
			// 	// console.log('Cart hidden');
			//   });
			// } else {
			//   console.log('Retrying to hide cart');
			//   setTimeout(hideLogoAndCart, 10); // Retry after 100ms
			// }
		  };
		  hideLogoAndCart();
		  setIsHeaderLoaded(true); // Set the state to true once the header script has loaded
		};
	  }
    
  }, []);

  useEffect(() => {
    const handleClickOutsideWithPassive = (event: MouseEvent): void => {
      handleClickOutside(event);
    };

    if (isVisible) {
      document.addEventListener('mousedown', handleClickOutsideWithPassive, { passive: true });
    } else {
      document.removeEventListener('mousedown', handleClickOutsideWithPassive);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutsideWithPassive);
    };
  }, [isVisible]);

  const openBannerHandler = () => {
    dispatch(toggleBanner());
  };
  
  useEffect(() => {
    if ((window as any).showBanner === 'Yes' && shouldRenderSideNav) {
      dispatch(openBanner());
    }
  }, []); // Run only once on mount


  
  return (
    <div id='customHeader' className='customHeader' style={{ display: 'flex', alignItems: 'center'}}>
      <header id="header" style={divStyle}></header>
     
      {isHeaderLoaded && (
      <>
      
      {((window as any).showBanner === 'Yes' && shouldRenderSideNav) ? ( <IconBell filled size={36} className='icon-bell' onClick={()=>openBannerHandler()}/> ) : ('')}

        <Form className="d-flex align-items-center ms-3">
          {(window as any).username || true ? (
            <div style={styles.wrapper}>
          {!window.location.pathname.includes('signup') && (
          <div style={styles.avatarPadding}>
            <Avatar size={48} button onClick={toggleVisibility} label={firstname[0] + " " + lastname[0]} />
          </div>
          )}
              
              {isVisible && (
                <Card
                  background="filled"
                  content={
                    <div style={styles.container} ref={popupRef}>
                      <div style={styles.detailsContainer}>
                        <div style={{ display: 'flex', gap: '15px', marginTop:'5px', marginBottom: '15px', paddingBottom:'8px', alignItems: 'center', borderBottom: "1px solid #ccc" }}>
                          <Avatar size={48} label={firstname[0] + " " + lastname[0]} />
                          <div>
                            <div id="nameDisplay" className="label" style={{ whiteSpace: 'nowrap' }}><span dangerouslySetInnerHTML={{ __html: firstname + " " + lastname }}></span></div>
                            <div className="caption" style={{ whiteSpace: 'nowrap' }}>{email}</div>
                            <div className='mb-1 caption'><a href='javascript:void(0)' onClick={navigateToProfile}  title="Profile and Settings" className='profile-link' >{t('HPI.DefaultMaster.cs.EditProfile',{defaultValue:'Edit Profile'})}</a></div>
                          </div>
                        </div>
                        <Button onClick={handleSignout} appearance="secondary" expanded small>
                          {t('HPI.DefaultMaster.cs.SignOut',{defaultValue:'Sign Out'})}
                        </Button>
                      </div>
                    </div>
                  }
                />
              )}
            </div>
          ) : (
            ""
          )}
        </Form>
      </>
        
        
      )}
    </div>
  );
};

export default Header;